import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function resetMobileViewport() {
  const viewport = document.querySelector('meta[name="viewport"]');
  if (viewport) {
    viewport.setAttribute('content',
      'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0, viewport-fit=cover'
    );
  }
}

const NON_PRODUCT_URL_PATTERNS = [
  /^https?:\/\/share\.google\.[a-z.]+\//i,
  /^https?:\/\/[^/]*google\.[a-z.]+\/search/i,
  /^https?:\/\/[^/]*google\.[a-z.]+\/maps/i,
  /^https?:\/\/[^/]*google\.[a-z.]+\/travel/i,
  /^https?:\/\/[^/]*google\.[a-z.]+\/flights/i,
  /^https?:\/\/[^/]*google\.[a-z.]+\/?$/i,
  /^https?:\/\/[^/]*bing\.[a-z.]+\/search/i,
  /^https?:\/\/[^/]*yahoo\.[a-z.]+\/search/i,
  /^https?:\/\/[^/]*duckduckgo\.[a-z.]+\//i,
  /^https?:\/\/[^/]*youtube\.[a-z.]+\/results/i,
  /^https?:\/\/[^/]*youtube\.[a-z.]+\/playlist/i,
  /^https?:\/\/[^/]*youtube\.[a-z.]+\/channel/i,
  /^https?:\/\/[^/]*youtube\.[a-z.]+\/@/i,
  /^https?:\/\/[^/]*facebook\.[a-z.]+\/(groups|pages|events|profile)/i,
  /^https?:\/\/[^/]*instagram\.[a-z.]+\/(explore|stories)/i,
  /^https?:\/\/[^/]*twitter\.[a-z.]+\/search/i,
  /^https?:\/\/[^/]*x\.[a-z.]+\/search/i,
  /^https?:\/\/[^/]*tiktok\.[a-z.]+\/(tag|discover)/i,
  /^https?:\/\/[^/]*pinterest\.[a-z.]+\/search/i,
  /^https?:\/\/[^/]*reddit\.[a-z.]+\/r\//i,
  /^https?:\/\/[^/]*linkedin\.[a-z.]+\/(feed|jobs|search)/i,
  /^https?:\/\/docs\.google\.[a-z.]+\//i,
  /^https?:\/\/drive\.google\.[a-z.]+\//i,
  /^https?:\/\/sheets\.google\.[a-z.]+\//i,
  /^https?:\/\/slides\.google\.[a-z.]+\//i,
  /^https?:\/\/calendar\.google\.[a-z.]+\//i,
  /^https?:\/\/mail\.google\.[a-z.]+\//i,
  /^https?:\/\/meet\.google\.[a-z.]+\//i,
  /^https?:\/\/[^/]*wikipedia\.[a-z.]+\//i,
  /^https?:\/\/[^/]*bit\.ly\//i,
  /^https?:\/\/[^/]*t\.co\//i,
  /^https?:\/\/[^/]*tinyurl\.[a-z.]+\//i,
  /^https?:\/\/[^/]*goo\.gl\//i,
  /^https?:\/\/wa\.me\//i,
  /^https?:\/\/[^/]*whatsapp\.[a-z.]+\//i,
  /^https?:\/\/t\.me\//i,
  /^https?:\/\/[^/]*telegram\.[a-z.]+\//i,
  /^https?:\/\/[^/]*zoom\.[a-z.]+\//i,
  /^https?:\/\/[^/]*teams\.microsoft\.[a-z.]+\//i,
  /^https?:\/\/[^/]*discord\.[a-z.]+\//i,
  /^https?:\/\/[^/]*spotify\.[a-z.]+\//i,
  /^https?:\/\/[^/]*netflix\.[a-z.]+\//i,
  /^https?:\/\/[^/]*twitch\.[a-z.]+\//i,
];

export function isProductUrl(url: string): boolean {
  if (!url) return false;
  const trimmed = url.trim();
  for (const pattern of NON_PRODUCT_URL_PATTERNS) {
    if (pattern.test(trimmed)) return false;
  }
  try {
    const parsed = new URL(trimmed);
    const path = parsed.pathname.replace(/\/+$/, '');
    if ((!path || path === '') && !parsed.search) return false;
  } catch {
    return false;
  }
  return true;
}

export function decodeHtmlEntities(text: string): string {
  // Handle multiple levels of encoding by repeating the process
  let decoded = text;
  let previousDecoded = '';
  
  // Keep decoding until no more changes occur (handles double/triple encoding)
  while (decoded !== previousDecoded) {
    previousDecoded = decoded;
    const textarea = document.createElement('textarea');
    textarea.innerHTML = decoded;
    decoded = textarea.value;
  }
  
  return decoded;
}
